module.exports = __webpack_public_path__ + "media/images/top/original02-bc7937405c784c059272a04ec627645c.jpg";